<template lang="pug">
    v-app
        snackbar-modal
        router-view
</template>

<script>
import SnackbarModal from '@/components/SnackbarModal/SnackbarModal'
import {mapActions} from 'vuex'

export default {
    name: 'app',
    props: {},
    data: function(){
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    components: {SnackbarModal},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss">
    
</style>